import { RadioSelectSettings } from './types';

const commonSettings = {
  paddingTop: 3,
  paddingRight: 5,
  paddingBottom: 3,
  paddingLeft: 5,
  '&:focus-visible': {
    outlineColor: 'primary.light',
    outlineStyle: 'solid',
    outlineWidth: '3px',
    zIndex: 1,
  },
};

export const radioSelectSettings: RadioSelectSettings = {
  componentVariants: {
    state: {
      prop: 'state',
      variants: {
        active: {
          backgroundColor: 'success.main',
          color: 'white.main',
          boxShadow: '0 0 0 1px #3B7D5B',
        },
        inactive: {
          backgroundColor: 'white.main',
          color: 'success.dark',
          boxShadow: '0 0 0 1px #BDC5CA',
          '&:hover': {
            backgroundColor: 'success.light',
          },
        },
      },
    },
    variant: {
      prop: 'variant',
      variants: {
        primary: {
          borderRadius: 3,
          boxShadow: '0px 2px 4px rgba(2, 11, 17, 0.15)',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        small: {
          ...commonSettings,
        },
        regular: {
          ...commonSettings,
        },
      },
    },
  },
};
